import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { TextField, DatePicker } from 'redux-form-material-ui';
import Subheader from 'material-ui/Subheader';

import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

import { reportPrePayment, deletePrePayment } from 'actions/landlordTenantsActions';

import { MdDelete as DeleteIcon } from 'react-icons/md';

// import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import { getTranslatedString } from 'helpers/i18n';

let PrePaymentsForm = class extends Component {
  render() {
    const style = {
      subheader: {
        lineHeight: 0,
        padding: '0 0 15px',
      },
      payment_details: {
        fontSize: '12px',
      },
      receipt_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    return (
      <form id="form_field">
        <div style={{ textAlign: 'center', fontSize: '14px' }}>
          {getTranslatedString('landlordPortal.prePaymentsForm.prePaymentDetails')}
          <br />
          <b style={{ fontFamily: 'Circular-Bold', color: colors.RED }}>
            {' '}
            {getTranslatedString('landlordPortal.prePaymentsForm.prePaymentNote')}
          </b>
          {getTranslatedString('landlordPortal.prePaymentsForm.prePaymentAlert')}
        </div>

        <div className="row">
          <div className="col-xs-6" style={{ textAlign: 'center' }}>
            <div style={{ margin: 'auto', textAlign: 'initial' }}>
              <Field
                name="effective_date"
                component={DatePicker}
                openToYearSelection={true}
                style={{ fontSize: '15px' }}
                textFieldStyle={{ fontSize: '15px' }}
                textLabelStyle={{ fontSize: '15px' }}
                formatDate={formatter.reformatDate}
                autoOk={true}
                fullWidth
                floatingLabelText={getTranslatedString(
                  'landlordPortal.prePaymentsForm.prePaymentEffectiveDate'
                )}
                validate={[validator.required]}
              />
            </div>
          </div>
          <div className="col-xs-6" style={{ textAlign: 'center' }}>
            <div style={{ margin: 'auto', textAlign: 'initial' }}>
              <Field
                name="amount"
                component={TextField}
                validate={[validator.required, validator.greaterThanZero]}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.prePaymentsForm.prePaymentAmount'
                )}
                multiLine={true}
                fullWidth
                rows={1}
                style={{ fontSize: '15px' }}
                {...formatter.currencyMask}
              />
            </div>
          </div>
        </div>

        <div style={{ alignItems: 'center' }}>
          {this.props.prePayments.length > 0 && (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {getTranslatedString('landlordPortal.prePaymentsForm.prePaymentHistory')}
                  </p>
                </div>
              </div>
              <div className="row" style={{ maxWidth: '520px', margin: 'auto', marginTop: '25px' }}>
                <div className="row">
                  <div className="col-xs-7" style={{ padding: '0' }}>
                    <Subheader inset={false} style={style.subheader}>
                      {getTranslatedString(
                        'landlordPortal.prePaymentsForm.prePaymentEffectiveDate'
                      )}
                    </Subheader>
                  </div>
                  <div className="col-xs-1" style={{ padding: '0', marginLeft: '-28px' }}>
                    <Subheader inset={false} style={style.subheader}>
                      {getTranslatedString('landlordPortal.prePaymentsForm.prePaymentAmount')}
                    </Subheader>
                  </div>
                </div>

                {this.props.prePayments.map((prePayment, index) => (
                  <div key={index} className="row">
                    <div className="col-xs-7" style={{ padding: '0' }}>
                      <p style={style.payment_details}>{prePayment.effective_date}</p>
                    </div>
                    <div className="col-xs-4" style={{ padding: '0', marginLeft: '-28px' }}>
                      <p style={style.payment_details}>
                        {formatter.formatMoney(prePayment.amount_remaining)}/
                        {formatter.formatMoney(prePayment.amount)}
                      </p>
                    </div>
                    <div
                      className="col-xs-1"
                      style={{
                        padding: '0',
                        paddingLeft: '12px',
                        marginTop: '-5px',
                        marginLeft: '28px',
                      }}
                    >
                      {prePayment.amount_remaining === prePayment.amount && (
                        <DeleteIcon
                          onClick={() => this.props.deletePrePayment(prePayment.id)}
                          size={24}
                          style={{
                            padding: '0',
                            verticalAlign: 'bottom',
                            position: 'absolute',
                          }}
                        />
                      )}
                    </div>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </form>
    );
  }
};

PrePaymentsForm = reduxForm({
  form: 'pre_payments_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(PrePaymentsForm);

PrePaymentsForm = connect(
  (store) => ({
    prePayments: store.landlordTenants.prePayments,
    leaseId: store.landlordTenants.leaseId,
  }),
  {
    onSubmit: reportPrePayment,
    deletePrePayment,
  }
)(PrePaymentsForm);

export default PrePaymentsForm;
